import refs from '../helpers/refs'

class CGravityHowItWorksStill {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-gravity-how-it-works-still')
    .forEach(el => new CGravityHowItWorksStill(el))
})
